import React from "react";
import "./StampPop.css";

const StampPop = ({ data, onClose }) => {
  if (!data) return null;

  const {
    timestamps_list = [],
    timestamps_string = "",
    model,
    language,
    video_duration,
  } = data;

  const handleCopyAll = async () => {
    try {
      await navigator.clipboard.writeText(timestamps_string);
    } catch (err) {
      console.error("Failed to copy timestamps", err);
    }
  };

  const handleCopyLine = async (line) => {
    try {
      await navigator.clipboard.writeText(line);
    } catch (err) {
      console.error("Failed to copy line", err);
    }
  };

  const handleBackdropClick = (e) => {
    // Only close if clicking directly on the backdrop, not on the popup content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handlePopupClick = (e) => {
    // Stop propagation to prevent backdrop click from firing when clicking inside popup
    e.stopPropagation();
  };

  return (
    <div className="stamp-pop-backdrop" onClick={handleBackdropClick}>
      <div className="stamp-pop" onClick={handlePopupClick}>
        <div className="stamp-pop-header">
          <h3>Generated Timestamps</h3>
          <button className="stamp-pop-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="stamp-pop-meta">
          <span>Model: {model}</span>
          <span>Language: {language}</span>
          <span>Duration: {video_duration} min</span>
        </div>

        <div className="stamp-pop-list">
          {timestamps_list.map((line, idx) => (
            <div key={idx} className="stamp-pop-line">
              <span className="stamp-pop-text">{line}</span>
              <button
                className="stamp-pop-copy"
                onClick={() => handleCopyLine(line)}
              >
                Copy
              </button>
            </div>
          ))}
        </div>

        <div className="stamp-pop-footer">
          <button className="stamp-pop-copy-all" onClick={handleCopyAll}>
            Copy All
          </button>
        </div>
      </div>
    </div>
  );
};

export default StampPop;
